import csv from 'csvtojson';

class CsvToJsonService {
    async convertCsvToJson(csvBlob: Blob) {
        const csvJson = await csvBlob.text().then((text) => {
            return csv().fromString(text);
        })
        return csvJson;
    }

    async fetchCsvAndConvertToJson(url: string) {
        const response = await fetch(url);
        const reader = response!.body!.getReader();
        let result = await reader.read();
        const decoder = new TextDecoder('utf-8');
        const csvChunks = [];
        // the data in the csv file is too large to be read in one shot,
        // therefore it is fetched in chunks.
        while (!result.done) {
          const csvChunk = decoder.decode(result.value)
          csvChunks.push(csvChunk);
          result = await reader.read();
        }
        const csvBlob = new Blob(csvChunks);
        return await this.convertCsvToJson(csvBlob);
    }
}

export default new CsvToJsonService();